export const SUBSCRIBE_INTEGRATION = 'SETTINGS/ADMINISTRATION/INTEGRATION/SUBSCRIBE_REQUEST';
export const SUBSCRIBE_INTEGRATION_SUCCESS = 'SETTINGS/ADMINISTRATION/INTEGRATION/SUBSCRIBE_SUCCESS';
export const SUBSCRIBE_INTEGRATION_FAILURE = 'SETTINGS/ADMINISTRATION/INTEGRATION/SUBSCRIBE_FAILURE';
